module.exports = __webpack_public_path__ + "static/img/top.75c0210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/top.png
// module id = DDTJ
// module chunks = 0